import React, { Component } from 'react';
import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css';
import './OrgChart.css';
import {Button,Row,Col} from 'reactstrap';
import InfoMessage from '../../Message/InfoMessage/InfoMessage';

class MapHierarchy extends Component {
  state = {
    treeData: [{ title: 'Chicken', subtitle:'subtitle', children: [{ title: 'Egg' }] }],
  };
  render() { 
    const {officeHierarchy} = this.props;
    return ( 
      <div>
        <div className="item-subheader">
          Let's define your organizational hierarchy representing the reporting structure
          of your enterprise. Please drag and drop the boxes, 
          until you see the right organizational hierarchy.
        </div>
        <div className="mt40" style={{height:'100%'}}>
          <SortableTree
            treeData={officeHierarchy}
            onChange={treeData => this.props.onHierarchyChange(treeData)}
            generateNodeProps={({ node, path }) => {
              return {
                className:  'drag-node',
              };
            }}
            canDrag={({node}) => !node.dragDisabled}
            isVirtualized={false}
          />
        </div>
        <div className="mt40">
          <InfoMessage 
            msg="Please check to make sure the organizational hierarchy is accurate." 
            subMsg="Organizational hierarchy allows you to drill-down in the Analytics module."
          />
        </div>
        <Row className="mt40 mb10 clearfix">
          <Col sm={{ size: '6' }} style={{ padding: '0'}}>
            <Col sm={{ size: '6'}}>
            <Button
              className="float-left goBackBtn w100"
              onClick={this.props.goBack}>
              <span className="cancelBtnTxt">
                <span className="ml10 flaticon-back" /> Go Back
              </span>
            </Button>
            </Col>
          </Col>
          <Col sm={{ size: '6' }} style={{ padding: '0'}}>
            <Col sm={{ size: '6', offset: 6 }} >
            <Button
              className="float-right continueBtn w100 ml10"
              onClick={this.props.onHierarchyMapped}>
              <span className="continueBtnTxt">
                Continue <span className="ml10 flaticon-next" />
              </span>
            </Button>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}
 
export default MapHierarchy;